import {_, Backbone} from "backboneAdapter";
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import ContentTilesView from 'js/views/content.tiles.view';
import ContentFileUploadView from 'js/views/contentfileupload.view';
import ComponentModel from 'js/models/component.model';
import CampaignConfiguration from 'js/models/campaign.config.model';
import UserModel from 'js/models/userrelatedinfo.model';
import UserServiceFilesTemplate from 'js/templates/service.theme.userfiles.hbs';
import moment from 'moment';
import i18n from 'l10n';
import GroupModel from 'js/models/group.model';
import Graphable from 'js/traits/graphable.trait';
import dhtmlx from 'dhtmlxAdapter';
import Optional from 'optional-js';
import {el, mixin, on, tagName} from "../adapters/backbone-decorators";

require('interfaceAdapter');

@el("#edit-voucher")
@tagName('div')
@mixin(Graphable)
class ServiceGenericView extends GenericView {

    /** Initialization and Render ~ START **/
    trackingUnload = true;
    userServiceFilesTemplate = Handlebars.compile(UserServiceFilesTemplate);
    serviceThemesTemplate = Handlebars.compile('{{>servicesthemes}}');
    draggingCustomBgImage = false;
    invalidFieldName = null;
    serviceType = "Generic";
    shouldPageReloadWait = false; //flag, that does not let "campaignStatusChanged"
    // Backbone event to reload the page, until something else happens first

    themeImageDragging = { //init it here to avoid `undefined` value
        drag: false,
        elem: null,
        imgHeight: '1px', //to avoid dividing with 0
        bottomPartToMove: null,
        elemTop: null,
        mouseY: null,
        valueToSave: null
    };

    ServiceTypes = {
        TELLODY_VOUCHER: "voucher",
        TELLODY_SURVEY: "survey",
        EMAIL_OPTIN: "optin",
        QUIZ_OPTIN: "quiz",
        INSTANT_WIN: "instantWin",
        PAY_PAL_PAYMENT: "payPalPayment"
    };

    contentFileUploadView = new ContentFileUploadView({
        el: 'body',
        startHidden: true,
        dropZone: 'body',
        voucherView: this,
        model: new Backbone.Model({
            uploadUrl: "/CampaignCloud/Content/UploadContent"
        }),
        inVoucherConfiguration: true
    });

    constructor(isPostPaid, model) {
        super();

        this.isPostPaid = isPostPaid;
        this.model = model;
        this.trackingUnload = !this.isConfigured();

        this.on("changed:campaignStatus", response => {
            if (this.model.get("id") === response.id && !this.shouldPageReloadWait)
                location.reload();
        });

        $(window).on("resize", () => {
            this.calculateAndMoveBackgroundImage.call(this, $("#bg-photo"));
            this.calculateAndMoveBackgroundImage.call(this, $("#bg-photo-mobile"));
            this.calculateAndMoveBackgroundImage.call(this, $('[id="bg-photo-pass"]'));
            if (this.model.get("campaignTemplateType") !== "TELLODY_VOUCHER") {
                this.calculateAndUpdatePostEntryMask();
            }
        });

        this.on("closed:contentSelector", () => {
            delete $.Dialog.extendedConfiguration;
        }, this);

        if (this.model.get("campaignId") === 0) {
            $(window).unbind("datetimepicker:clearDateButtonClicked").on("datetimepicker:clearDateButtonClicked", (event, attribute, objectId, datetimepicker) => {
                if (objectId === this.model.get("id")) {
                    if (attribute === "eventStartDate" || attribute === "eventEndDate") {
                        this.setEventDateToNull(attribute);
                    } else if (attribute === "endDate") {
                        this.setExpirationDateToNever(attribute, datetimepicker);
                    }
                }
            });

            $(window).unbind("datetimepicker:focusout").on("datetimepicker:focusout", (event, attribute, objectId) => {
                if (objectId === this.model.get("id")) {
                    $(`#${attribute}Config`).find("form").submit();
                }
            });
        }
        // self.render();
    }

    isConfigured() {
        return this.model.get('campaignId') !== 0;
    }

    @on('click #showcolor')
    clickShowColor() {
        $("#backgroundColorSelector").click();
    }

    @on('mouseover #toggleImagePositionMovement')
    mouseOverToggleImageMove(e) {
        $(e.currentTarget).show();
    }

    @on('mouseover #bg-photo')
    mouseOverBgPhoto(e) {
        this.toggleCustomBgImageFunctions(e, "show");
    }

    @on('mouseout #toggleImagePositionMovement')
    mouseOutImageMove(e) {
        this.toggleCustomBgImageFunctions(e, "hide");
    }

    @on('mouseout #showcolor')
    mouseOutShowColor(e) {
        e.stopPropagation();
        this.toggleCustomBgColorFunctions(e, "hide");
    }

    @on('mouseout #bg-color')
    mouseOutBgColor(e) {
        this.toggleCustomBgColorFunctions(e, "hide");
    }

    @on('mouseout #bg-photo')
    mouseOutBgPhoto(e) {
        this.stopImageDragging(e);
        this.toggleCustomBgImageFunctions(e, "hide");
    }

    @on('mouseover #showcolor')
    mouseOverShowColor(e) {
        e.stopPropagation();
        this.toggleCustomBgColorFunctions(e, "show");
    }

    @on('mouseover #bg-color')
    mouseOverBgColor(e) {
        this.toggleCustomBgColorFunctions(e, "show");
    }

    @on("change .backgroundColor")
    @on("change .fontColor")
    render() {
        this.model.uurlPrefix = (/^app/.test(window.location.host)) ? '' : window.location.host.charAt(0);
        $(this.isPostPaid ? "#telly" : "#win").css('display', 'none');

        super.render();
        const $bg = $("#bg-photo");
        this.bgImageDimensions = this.getBackgroundImageDimensions($bg);
        if (this.model && this.model.get("campaignId") === 0) {
            this.calculateAndMoveBackgroundImage.call(this, $bg);
            this.calculateAndMoveBackgroundImage.call(this, $('#bg-photo-mobile'));
            this.calculateAndMoveBackgroundImage.call(this, $('[id="bg-photo-pass"]'));
        } else if (this.model && this.model.get("campaignId") > 0) {
            $("#changeToServicePage").one("click", () => {
                setTimeout(() => {
                    this.calculateAndMoveBackgroundImage.call(this, $('#bg-photo'));
                    this.calculateAndMoveBackgroundImage.call(this, $('#bg-photo-mobile'));
                    this.calculateAndMoveBackgroundImage.call(this, $('[id="bg-photo-pass"]'));
                    this.calculateBigTexts(null);
                }, 1);
            });
        }
        this.showDependencyGraph();

        return this;
    }

    @on("click #createGroups")
    toggleCreateGroups() {
        this.toggleVisibilityOfElement("#creategroupfloatingbutton", "toggle");
    }

    @on('keydown .edit')
    handleEditableKeydown(e) {
        const TAB_KEY = 9;
        if (e.keyCode === TAB_KEY) {
            e.preventDefault();
            const $edit = $(".edit");
            const index = $edit.index(e.currentTarget) + (e.shiftKey ? -1 : 1);
            $edit.get(index).click();
        }
    }

    @on('click .tab-control>.tabs>li')
    scrollFilesAccordionToTop() {
        $($(".content").find(".frames")[0]).scrollTop(0); //for better UX
    }

    @on('click .openFileSelectDialog')
    displayContentSelector(e) {
        var selectedFile;
        var campaignTemplateType = this.model.get("campaignTemplateType");
        if (e.newComponent) {
            $.Dialog.extendedConfiguration = {type: e.type};
            selectedFile = undefined;
        } else {
            selectedFile = campaignTemplateType === "TELLODY_VOUCHER"
                ? this.model.get("voucherPageConfig").get('logoContentId')
                : this.qCollection.models[$(e.currentTarget).data("index")].get("imageId");
        }
        $.Dialog({
            overlay: true,
            shadow: true,
            icon: '<span class="icon  icon-file" style="color:white"></span>',
            title: i18n.t("survey.selectimage"),
            draggable: false,
            height: 'auto',
            position: ['center', 'center'],
            content: '<div id="file-selector-window" class="changepadding10to5"></div>',
            padding: 0,
            onShow: (_dialog) => {
                _dialog.find('.content').css('overflow', 'auto');
                const contentCollectionView = new ContentTilesView({
                    el: "#file-selector-window",
                    inVoucherConfiguration: this.model.get("campaignId") === 0 &&
                        this.model.get("campaignTemplateType") === "TELLODY_VOUCHER",
                    inServiceConfiguration: true,
                    selectedFile: selectedFile
                });
                contentCollectionView.off("uploaded:content").on("uploaded:content", this.loadServiceFiles, this);

                contentCollectionView.off("selected:content").on("selected:content", async e => {
                    if (e.source && e.source.hasClass("content-gallery-container")) {
                        await this.selectServiceBackgroundImage(e.model.get("contentId"));
                    } else {
                        this.insertContentOnService(_.extend(e, $.Dialog.extendedConfiguration));
                        $.Dialog.close();
                    }
                }, this);

                var $file = $("#file-selector-window");
                $file.prepend('<div class="fileup" />');
                this.contentFileUploadView = new ContentFileUploadView({
                    el: '#file-selector-window .fileup',
                    dropZone: '#file-selector-window',
                    model: new Backbone.Model({
                        uploadUrl: "/CampaignCloud/Content/UploadContent"
                    }),
                    inVoucherConfiguration: this.model.get("campaignId") === 0 &&
                        this.model.get("campaignTemplateType") === "TELLODY_VOUCHER",
                    inServiceConfiguration: true
                });
                contentCollectionView.listenTo(this.contentFileUploadView, "uploaded:content", contentCollectionView.renderCollection);

                if (this.model.get("campaignId") === 0 && this.model.get("campaignTemplateType") === "TELLODY_VOUCHER") {
                    $file.find('#defaultLogo').unbind().bind("click", () => {
                        this.trigger("selected:voucherDefaultContent");
                    });
                }
            },
            sysBtnCloseClick: e => {
                this.trigger("closed:contentSelector", e);
            }
        });
    }

    insertContentOnService(e) {
        var model = e.model;
        var existingContentId;
        var surveyCompId = this.lastOpenedComponentConfig;
        var id = model.get(model.idAttribute);
        var CCmodel = this.model;
        var cTT = CCmodel.get("campaignTemplateType");
        if (cTT === "TELLODY_VOUCHER") {
            existingContentId = CCmodel.get("voucherPageConfig").get('logoContentId');
            if (!existingContentId || (existingContentId && existingContentId !== id)) {
                existingContentId = id;
                $.ajaxDefaultQ({
                    url: `/CampaignCloud/Content/LoadFileContent/${existingContentId}`,
                    type: 'GET',
                    contentType: "application/json",
                    dataType: 'json'
                }).then(contentData => {
                    if (contentData) {
                        if (contentData.fileSubType === "svg+xml") {
                            $.Notify.show(i18n.t("content.svgNotSupportedOnVouchers"));
                        } else {
                            this.changeContent(existingContentId);
                            $.Dialog.close();
                        }
                    }
                });
            }
        } else {
            if (surveyCompId !== undefined && surveyCompId !== null) {
                var comp = this.qCollection.at(surveyCompId);
                comp.set("imageId", id);
                if (comp.hasChanged()) {
                    this.changeComponentContent(comp.get("imageId"), surveyCompId, comp.get("logo"));
                }
            } else {
                const newModel = new ComponentModel({type: e.type || "SurveyImage"});
                newModel.set("imageId", id);
                this.createAndSaveComponent(newModel);
            }
        }
    }

    @on('click #clone')
    async cloneCampaign() {
        try {
            const id = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Message/${this.model.get("id")}/clone`,
                type: 'POST',
                dataType: 'text'
            });
            window.location.assign(`./Service.htm#${id}`); //.assign -> load a new
            // document (same functionality as `window.location.href`)
            window.location.reload(); //reload the now "changed" window.location,
            // to avoid having DHTXML events being bound more than once

        } catch (e) {
            console.error(e);
        }
    }

    /** Initialization and Render ~ END **/
    /** Core Logic ~ START **/
    setServiceStatus() {
        const serviceStatus = this.model.get("campaignStatus");
        this.setStatusFor(this.ServiceTypes[this.model.get("campaignTemplateType")], this.model, serviceStatus);
    }

    setStatusFor(type, model, status) {
        const obj = Handlebars.helpers.getStatusAndIconFor(type, model, status);

        $(`#${type}StatusIcon`).html(obj.htmlIcon);
        $(`#${type}StatusText`).html(obj.htmlText);
        $(`#${type}-creation-date`).html(obj.htmlCreation);
    }

    @on('click #setupSmsTriggeringEvent')
    setupSmsTriggeringEvent(ev) {
        this.setupTriggeringEvent('SMS', 'tellody-event');
    }

    @on('click #setupEmailTriggeringEvent')
    setupEmailTriggeringEvent(ev) {
        this.setupTriggeringEvent('EMAIL', 'tellody-event');
    }

    setupTriggeringEvent(channel, description) {
        const campaignId = this.model.get("campaignId");

        const ceByTt = {
            TELLODY_SURVEY: "SurveyAnswerRequest\\campaignId=",
            TELLODY_VOUCHER: "RedeemVoucherEvent\\campaignId=",
            EMAIL_OPTIN: "EmailOptedInEvent\\campaignId=",
            INSTANT_WIN: "InstantWinActedWinnerEvent\\campaignId=",
            QUIZ_OPTIN: "InstantWinActedWinnerEvent\\campaignId=",
            SWEEPSTAKES: "InstantWinActedParticipantEvent\\campaignId="
        };
        const isSweepstakes = this.model.get("campaignTemplateType") === "INSTANT_WIN" && (
            Optional.ofNullable(this.model.get("instantWinPageConfig"))
                .map(m => m.get("type") === "USER_METRICS")
                .orElse(false)
        );

        const critExpr = (isSweepstakes ?
            ceByTt.SWEEPSTAKES
            : ceByTt[this.model.get("campaignTemplateType")]) + campaignId;


        const CCmodel = new CampaignConfiguration({
            campaignChannel: channel,
            campaignTemplateType: 'SMART_NOTIFICATION',
            triggeringCriterionExpression: critExpr,
            monitoringCriterionExpression: "false",
            monitoringDuration: 5,
            monitoringTimeInterval: "DAYS",
            controlGroupPercentage: 0,
            targetGroupPercentage: 100,
            message: "",
            successMessage: "",
            description: description
        });

        var userModel = new UserModel();
        userModel.fetch({
            success: function () {
                CCmodel.set("userId", userModel.id);
                CCmodel.set("sender", ((channel === 'SMS') ? userModel.get("username").replace(/\./g, "").substring(0, 11) : userModel.get("username")));

                CCmodel.save(CCmodel.attributes, {
                    success: function (model) {
                        location.href = `Message.htm#${model.get("id")}`;
                    }
                });
            }
        });

        return false;
    }

    /** Expiration Date Section ~ START **/
    expirationDateSubmit(input) {
        const df = "YYYY/MM/DD hh:mm";
        const inputToDate = moment(input.val(), df);

        if (inputToDate.isBefore(moment())) {
            const d = moment();

            const value = d.format(df);
            input.val(value);

            dhtmlx.alert(i18n.t("message.notpreviousdateavailable"));
        }

        const $id = $('[id="expireson-preview"]');
        $id.html(i18n.t("voucher.expireson") + input.val());
        $('[id="expireson"]').html(i18n.t("expireson") + input.val());

        const $id2 = $('[id="passPreviewExpireson"]');
        $id2.find(".expiresOnValue").text(input.val());

        $id.show();
        $id2.show();
    }

    checkExpirationDate() {
        var self = this;
        var currentDate = new Date().getTime();

        if (self.model.get("campaignId") > 0) {
            return true;
        }
        return !(self.model.get("endDate") && new Date(self.model.get("endDate")).getTime() < currentDate);


    }

    setExpirationDateToNever(attribute) {
        this.model.set(attribute, null);
        this.$('.datetimepicker').text(i18n.t("never"));
        $('[id="expireson-preview"]').text(i18n.t("voucher.expireson") + i18n.t("never"));
        $('[id="expireson"]').html(i18n.t("expireson") + +i18n.t("never"));
        $('#passPreviewExpireson').hide();
    }

    /** Expiration Date Section ~ END **/
    /** Group Section ~ START **/
    @on("click #create-yes-group")
    @on('click #create-participants-group')
    async createYesGroup() {
        var campaignId = this.model.get("campaignId");
        var service = this.ServiceTypes[this.model.get("campaignTemplateType")];
        var isSweepstakes = this.model.get("description") === "sweepstakes";
        var title = isSweepstakes ? ".sweepstakesnewgroupname" : ".newgroupname";
        var query = "in campaign(" + campaignId + ")";
        var text = isSweepstakes ? i18n.t("instantWin.createSweepstakesGroup") : i18n.t(`${service}.creategroup`);
        const result = await dhtmlx.confirm({
            type: "confirm",
            text: `${text}. ${i18n.t("generic.continue")}`,
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
        });

        if (result) {
            await this.createGroup(title, query, service);
        }
    }

    @on("click #create-no-group")
    async createNoGroup() {
        var campaignId = this.model.get("campaignId");
        var service = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
        var title = ".newgroupNoname";
        var query = `in ${service}(${campaignId}) /\\ not in campaign(${campaignId})`;
        const key = `${service}.createNogroup`;
        const result = await dhtmlx.confirm({
            type: "confirm",
            text: `${i18n.t(key)}. ${i18n.t("generic.continue")}`,
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
        });
        if (result) {
            await this.createGroup(title, query, service);
        }
    }

    async createGroup(title, query, service) {
        var model = new GroupModel({
            url: function () {
                return model.urlRoot;
            }
        });
        model.set("serviceType", service.toUpperCase()); //optin functionality should be added
        model.set("title", i18n.t(service + title, {title: this.model.get("title")}));
        model.set("groupType", "query");
        model.set("query", query);
        model.url = function () {
            return model.urlRoot;
        };
        model.isNew = function () {
            return true;
        };
        try {
            const responseModel = await model.save(model.attributes);
            if (responseModel) {
                var theModel = new GroupModel(responseModel.attributes);
                location.href = `Contacts.htm#Group/${model.get(theModel.idAttribute)}`;
            } else {
                $.Notify.error(`${i18n.t("generic.cloneoutcome")} ${responseModel}`);
            }
        } catch (e) {
            console.error(e);
            $.Notify.error(i18n.t("generic.cloneerror"));
        }
    }

    createGroupWithoutRedirecting(title, query, service) {
        const model = new GroupModel({
            url: () => model.urlRoot
        });
        model.set("serviceType", service.toUpperCase()); //optin functionality should be added
        model.set("title", i18n.t(service + title, {title: this.model.get("title")}));
        model.set("groupType", "query");
        model.set("query", query);
        model.url = () => model.urlRoot;
        model.isNew = () => true;

        return model.save(model.attributes);
    }

    /** Group Section ~ END **/
    endTitleSubmit(input) {
        $("#surveypreviewendtitle").text(input.val());
        this.calculateAndUpdatePostEntryMask();
    }

    endTextSubmit(input) {
        $("#surveypreviewendtext").text(input.val());
        this.calculateAndUpdatePostEntryMask();
    }

    endFooterSubmit(input) {
        $("#surveypreviewendfooter").text(input.val());
        this.calculateAndUpdatePostEntryMask();
    }

    ratingTitleSubmit(input) {
        var index = $(input).parent().parent().attr("data-index");
        $("#surveyRatingTitle" + index).text(input.val());
    }

    pagetitleSubmit(input) {
        $('[id="pagetitle"]').text(input.val());
        $('[id="passPreviewPageTitle"]').text(input.val());
        this.calculateBigTexts(null);
    }

    pagetextSubmit(input) {
        $('[id="pagetext"]').text(input.val());
    }

    footerSubmit(input) {
        $('[id="footer"]').text(input.val());
    }

    toggleExecuteButton(toEnable) {
        if (!toEnable) {
            this.$("#execute-send")
                .removeClass("fbg-hover-white fg-hover-emerald")
                .addClass("bg-hover-white fg-white fg-hover-red cursor-not-allowed")
                .attr("disabled", "disabled");
        } else {
            this.$("#execute-send")
                .removeClass("bg-hover-white fg-white fg-hover-red cursor-not-allowed")
                .addClass("bg-hover-white fg-hover-emerald")
                .removeAttr("disabled");
        }
    }

    @on("click #execute-send")
    async execute(boxTitle, boxText, alertText, buttons) {
        if (!this.validateCondition(this)) {
            dhtmlx.alert(i18n.t(this.invalidFieldName));
            return;
        }
        const isSweepstakes = this.model.get("instantWinPageConfig") &&
            this.model.get("instantWinPageConfig").get("type") &&
            this.model.get("instantWinPageConfig").get("type") === "USER_METRICS";
        const result = await dhtmlx.modalbox({
            title: boxTitle,
            text: boxText,
            buttons: buttons || [i18n.t("message.yes"), i18n.t("message.no"), i18n.t("message.later")]
        });
        if (result === "0") {
            if (alertText === false) {
                if (!this.isPostPaid)
                    location.href = "Credits.htm";
            } else {
                if (this.model.hasChanged())
                    await this.model.batchUpdate();
                this.trackingUnload = false;
                try {
                    const executionId = await $.ajaxDefaultQ({
                        url: `/CampaignCloud/Message/${this.model.get("id")}/execute`,
                        type: 'POST',
                        contentType: "application/json",
                        dataType: 'json'
                    });
                    if (executionId > 0) {
                        await dhtmlx.alert({
                            text: alertText
                        });
                        if (isSweepstakes) {
                            this.model.set("campaignId", executionId);
                            //stop the page from reloading (navbar listening on `/events`, to update status)
                            //until the winners group is created
                            this.shouldPageReloadWait = true;
                            await this.createInstantWinWinnersGroup(true);
                        } else {
                            location.reload();
                        }
                    } else if (executionId === 0) {
                        dhtmlx.alert(i18n.t("service.alreadyexecuted"));
                    } else if (executionId === -1) {
                        dhtmlx.alert(i18n.t("service.pointsalreadyexecuted"));
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        } else if (result === "2") {
            location.href = "Service.htm";
        }
    }

    @on('click #stopActiveService')
    async stopActiveService() {
        if (this.model.get("endDate") && this.model.get("endDate") <= Date.now()) {
            return;
        }

        const messageText = this.model.get("description") === "points"
            ? i18n.t("voucher.wantToStopPointsService")
            : i18n.t("voucher.wantToStopService");

        const result = await dhtmlx.confirm({
            type: "confirm",
            text: messageText,
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
        });
        if (result) {
            try {
                const data = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Message/${this.model.get("id")}/stop`,
                    type: 'POST'
                });
                if (data) {
                    await dhtmlx.alert(i18n.t("voucher.serviceStoppedSuccess"));
                    this.setServiceStatus();
                    $("#stopActiveService").parent().remove();
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    @on('click #delete-draft')
    async deleteDraft() {
        var campaignUUID = this.model.get(this.model.idAttribute);
        const result = await dhtmlx.confirm({
            type: "confirm",
            text: i18n.t("survey.confirmdeletion"),
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
        });
        if (!result) return;
        try {
            const deletionResult = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Message/${campaignUUID}/deleteDraft`,
                type: 'POST'
            });
            if (typeof deletionResult.message !== 'undefined') {
                if (deletionResult.message === "successfulDeletion") {
                    this.trackingUnload = false;
                    await dhtmlx.alert(i18n.t(`message.${deletionResult.message}`));
                    location.href = "Service.htm";
                } else {
                    dhtmlx.alert(i18n.t(`message.${deletionResult.message}`));
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    @on("click #showlamp")
    serviceThemesPrompt() {
        $.Dialog({
            overlay: true,
            shadow: true,
            icon: '<span class="icon  icon-file" style="color:white"></span>',
            title: i18n.t("survey.selecttheme"),
            draggable: false,
            height: 'auto',
            position: ['center', 'center'],
            content: this.serviceThemesTemplate(),
            padding: 0,
            onShow: _dialog => {
                _dialog.find('.content').css('overflow', 'auto');
                this.loadServiceFiles();
            }
        });
    }

    loadServiceFiles() {
        $(".content-gallery-container").empty();
        $("body .gettheclick").on('click', _.bind(this.selectServiceBackgroundTheme, this));
        $('body #serviceThemeImage').on('change', _.bind(this.selectServiceBackgroundColor, this));
        const pageConfig = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER"
            ? "voucher" : "survey";
        const selectedFile = this.model.get(`${pageConfig}PageConfig`).get("backgroundColor");
        const contentCollectionView = new ContentTilesView({
            el: ".content-gallery-container",
            inVoucherConfiguration: this.model.get("campaignId") === 0 &&
                this.model.get("campaignTemplateType") === "TELLODY_VOUCHER",
            inServiceConfiguration: true,
            selectedFile
        });
        contentCollectionView.off("uploaded:content").on("uploaded:content", this.loadServiceFiles, this);
        contentCollectionView.off("selected:content").on("selected:content", async e => {
            if (e.source && e.source.hasClass("content-gallery-container")) {
                await this.selectServiceBackgroundImage(e.model.get("contentId"));
            } else {
                this.insertContentOnService(_.extend(e, $.Dialog.extendedConfiguration));
                $.Dialog.close();
            }
        }, this);

        if (this.contentFileUploadView)
            this.contentFileUploadView.off("uploaded:content").on("uploaded:content", this.loadServiceFiles, this);
    }

    /** Core Logic ~ END **/
    /** Visual Helpers Section ~ START **/
    @on("click #post-entry-link")
    toggleVisibility() {
        this.calculateAndUpdatePostEntryMask();
        this.toggleVisibilityOfElement($("#showTab2"), "block");
        this.toggleVisibilityOfElement($("#showTab1"), "block");
        $("#postTab").addClass("active");
        $("#pretab").removeClass("active");
    }

    toggleVisibilityOfElement(element, display) {
        if (display === "toggle") {
            $(element).toggle();
        } else { //e.g. "display: none, block
            $(element).css("display", display);
        }
    }

    @on("click #pre-entry-link")
    toggleVisibility2() {
        this.toggleVisibilityOfElement($("#showTab1"), "none");
        this.toggleVisibilityOfElement($("#showTab2"), "none");
        $("#pretab").addClass("active");
        $("#postTab").removeClass("active");
    }

    @on('mouseout #showlamp')
    @on('mouseover #showlamp')
    showlampMouseEvents(e) {
        var isToShowLamp = e.type === 'mouseover';
        e.stopPropagation();
        if (this.draggingCustomBgImage) {
            return;
        } //do not show "lamp" if dragging image
        $(e.currentTarget).toggle(isToShowLamp);

        var pageConfig = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
        var bgCol = this.model.get(`${pageConfig}PageConfig`).get("backgroundColor");

        var isCustomImage = (/[a-zA-Z0-9]{24}/).test(bgCol);
        if (!isCustomImage) {
            return;
        } //do not show "Tap to edit" button
        $("#toggleImagePositionMovement").toggle(isToShowLamp);
    }

    @on('mousedown #dragImageText')
    @on('mouseup #dragImageText')
    dragImageTextMouseEvent(currEvent) {
        var self = this;
        this.transferEventTo(currEvent, $.Event(currEvent.type), $("#bg-photo"));
        currEvent.preventDefault();
    }

    toggleCustomBgImageFunctions(e, vis) {
        e.stopPropagation();
        var pageConfig = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
        var bgCol = this.model.get(`${pageConfig}PageConfig`).get("backgroundColor");
        var isCustomImage = (/[a-zA-Z0-9]{24}/).test(bgCol);
        if (this.model.get("campaignId") > 0) {
            return;
        }
        this.toggleBgCustomImageButtons(vis, isCustomImage);
    }

    toggleCustomBgColorFunctions(e, vis) {
        e.stopPropagation();
        var pageConfig = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
        var bgCol = this.model.get(`${pageConfig}PageConfig`).get("backgroundColor");
        var isCustomImage = (/[a-zA-Z0-9]{24}/).test(bgCol);
        if (this.model.get("campaignId") > 0) {
            return;
        }
        this.toggleBgColorCustomButtons(vis, isCustomImage);
    }

    getBackgroundImageDimensions($el) {
        var bgSrc = ($el.css('background-image').match(/^url\(['"]?(.*?)['"]?\)$/i) || [])[1];
        if (!bgSrc) return;

        var imageDimensions = {width: 0, height: 0},
            image = new Image();

        image.onload = function () {
            if ($el.css('background-size') === "cover") {
                var elementWidth = $el.innerWidth(),
                    elementHeight = $el.innerHeight(),
                    elementAspectRatio = elementWidth / elementHeight,
                    imageAspectRatio = image.width / image.height,
                    scale = 1;

                if (imageAspectRatio >= elementAspectRatio) {
                    scale = elementHeight / image.height;
                } else {
                    scale = elementWidth / image.width;
                }
                imageDimensions.width = image.width * scale;
                imageDimensions.height = image.height * scale;
            } else {
                imageDimensions.width = image.width;
                imageDimensions.height = image.height;
            }
        };

        image.src = bgSrc;

        return imageDimensions;
    }

    calculateAndUpdatePostEntryMask() {
        var $tab1 = $($(".previewMask")[0]); //mobile preview
        var $tab1Parent = $tab1.parent();

        var bgPhotoDivHeight = $($tab1Parent.find("#bg-photo-mobile").parent()).height();
        var bgPhotoImgHeight = self.bgImageDimensions ? self.bgImageDimensions.height : null;
        var currentHeight = $tab1Parent.height();
        var newHeight = $tab1Parent.height('auto').height(); //total_#bg-photo_height + total_#bg-color_height

        //set parent's height back to normal
        $tab1Parent.css("height", `${currentHeight}px`);

        //dynamically calculate mask's new, correct, height
        var correctHeight = newHeight + bgPhotoDivHeight - bgPhotoImgHeight >= currentHeight
            ? newHeight + bgPhotoDivHeight - bgPhotoImgHeight //in case of vertically long photos
            : newHeight + bgPhotoDivHeight; //in case of vertically small photos;


        var innerShowTabHeight;
        if ($tab1.css("display") === "block") {
            innerShowTabHeight = $tab1.find('.innerShowTab1').height();
        } else {
            //show and hide `$tab1` so we can get its height
            $tab1.show();
            innerShowTabHeight = $tab1.find('.innerShowTab1').height();
            $tab1.hide();
        }

        if (innerShowTabHeight > correctHeight) {
            //check innerShowTabHeight, in case of HUGE text inputed in the POST entry fields
            $tab1.css("height", 'auto');
        } else if (correctHeight < currentHeight) {
            //in case of having not much data (e.g. only 1 question)
            $tab1.css("height", '100%');
        } else {
            $tab1.css("height", `${correctHeight}px`);
        }

        var $showTab2 = $("#showTab2");
        var tab2 = $showTab2; //desktop preview, survey only
        var tab2Parent = $($showTab2.parent());
        $(tab2).css("height", tab2Parent.css("height"));
    }

    calculateBigTexts(options) {
        var defaultCustomOptions = {
            maximumFontSize: 60,
            horizontalAlign: "left",
            verticalAlign: "top",
            wordBreak: null
        };

        var elements = '[data-dynamic-font-size="true"]';
        var initialOptions = options !== null ? $.extend({}, defaultCustomOptions, options) : defaultCustomOptions;
        _.each($(elements), function (elem) {
            var finalOptions = $.extend({}, initialOptions);
            if ($(elem).data("dynamic-text-options") && $(elem).data("dynamic-text-options").length > 0) {
                var customDynamicTextOptions = $(elem).data("dynamic-text-options").split(";");
                _.each(customDynamicTextOptions, function (option) {
                    if (option) {
                        var label = option.split(":")[0].trim();
                        finalOptions[label] = option.split(":")[1].trim();
                    }
                });
            }

            //set the font size according to the text's length (mimic apple passes)
            $(elem).dynamicFontSize(finalOptions);
        });
    }

    bindPreviewTextareaHeightEvents() {
        $('.previewTextArea').each(function () {
            this.style = `{height:'${this.scrollHeight}px;overflow-y:hidden;}`;
        }).on('input', function () {
            this.style.height = 'auto';
            this.style.height = `${this.scrollHeight}px`;
        });
        var currInst = new Date();
        $('.previewDate').datetimepicker({
            format: i18n.t("$dateformat"),
            closeOnDateSelect: true,
            scrollInput: false,
            todayButton: false,
            timepicker: false,
            yearStart: 1900,
            yearEnd: new Date().getFullYear(),
            minDate: new Date("1/1/1900"), /*lower boundary*/
            maxDate: 0 /*upper boundary= today*/
        });
    }

    selectServiceBackgroundTheme(evt) {
        if (this.model.get("campaignId")) {
            return;
        }
        var service = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
        var classToSave = $(evt.currentTarget).attr('data-style');

        this.themeImageDragging.valueToSave = 1.0;
        const serviceConfig = this.model.get(service + "PageConfig");
        this.model.storeAttribute(service + "PageConfig." + "backgroundColor", classToSave);
        this.model.storeAttribute(service + "PageConfig." + "fontColor", `bg${classToSave}`);
        this.model.storeAttribute(service + "PageConfig." + "backgroundImagePosition", this.themeImageDragging.valueToSave);

        $.Dialog.close();
        this.render();
    }

    async selectServiceBackgroundImage(srcToSave) {
        if (this.model.get("campaignId")) {
            return;
        }
        try {
            var service = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
            const resp1 = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Content/LoadFileContent/${srcToSave}`,
                type: 'GET',
                contentType: "application/json",
                dataType: 'json'
            });

            const resp2 = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Content/getBgColorForContent/${srcToSave}`,
                type: 'GET',
                contentType: "application/json",
                dataType: 'text'
            });
            if (resp1) {
                if (resp1.fileSubType === "svg+xml" && service === "voucher") {
                    $.Notify.show(i18n.t("content.svgNotSupportedOnVouchers"));
                    return;
                } else {
                    this.themeImageDragging.valueToSave = 1.0; //needed for the predefined images, to be scrolled to bottom - values: [0,1]
                    var serviceConfig = this.model.get(service + "PageConfig");
                    serviceConfig.set("backgroundColor", srcToSave);
                    serviceConfig.set("backgroundImagePosition", this.themeImageDragging.valueToSave);
                    serviceConfig.set("fontColor", resp2.replace(/^ff/, "#"));
                    this.render();
                }
                $.Dialog.close();
            }
        } catch (e) {
            console.log(e);
        }
    }

    @on('change #backgroundColorSelector')
    selectServiceBackgroundColor(e) {
        var service = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
        var serviceConfig = this.model.get(`${service}PageConfig`);
        var colorToSave = $(e.currentTarget).val();
        serviceConfig.set("fontColor", colorToSave);
        $.Dialog.close();
        this.render();
    }

    toggleExecuteButtonCallback(condition, self) {
        self.toggleExecuteButton.call(self, condition); // False disables the execute button.
        return condition;
    }

    @on('mousedown #bg-photo')
    startImageDragging(e) {
        if (e.which !== 1 && !e.transferredFromText) {
            return;
        } //e.which == 1 => left mouse button
        $("#dragImageText").hide();
        var self = this;
        var elem = $(e.currentTarget);
        var elemHeight = parseInt(elem.css("height"));
        var bottomPartToMove = elemHeight - self.bgImageDimensions.height;

        if (!elem.hasClass('dragme')) {
            return;
        }

        var mouseY = parseInt(e.pageY);
        var elemTop = parseFloat(elem.css("background-position").split(" ")[1]);
        var drag = true;

        self.themeImageDragging = {
            drag: drag,
            elem: elem,
            imgHeight: self.bgImageDimensions.height,
            bottomPartToMove: bottomPartToMove,
            elemTop: elemTop,
            mouseY: mouseY,
            valueToSave: elemTop / (elemHeight - self.bgImageDimensions.height)
        };

        $(elem).on("mousemove", {self: self}, self.dragThemeImage);
        $(elem).on("mouseout", function () {
            $(elem).unbind("mousemove");
        });

        e.preventDefault(); //needed!!! Disables dragging and opening of an image (Firefox), dragging and previewing an image (Chrome)
        console.info("Dragging...STARTED");
    }

    @on('mouseup #bg-photo')
    stopImageDragging(e) {
        //e.which == 1 => left mouse button
        if ((e.which === 1 || e.transferredFromText || $(e.currentTarget).hasClass("dragme")) && this.themeImageDragging.drag) {

            $("#dragImageText").show();
            var self = this;

            var elem = $(e.currentTarget);
            $(elem).unbind("mousemove");
            self.themeImageDragging.drag = false;

            self.themeImageDragging.elemTop = parseFloat($(elem).css("background-position").split(" ")[1]);
            self.themeImageDragging.valueToSave = self.themeImageDragging.elemTop / (self.themeImageDragging.elem.height() - self.bgImageDimensions.height);

            e.preventDefault(); //needed!!! Disables dragging and opening of an image (Firefox), dragging and previewing an image (Chrome)
            console.info("Dragging...STOPPED");
        }
    }

    dragThemeImage(e) {
        if (e.which === 1 || e.transferredFromText) {
            var self = e.data.self;

            var elem = $(e.currentTarget);
            var currentMouseY = parseInt(e.pageY);

            var moveTo = self.themeImageDragging.elemTop + (currentMouseY - self.themeImageDragging.mouseY);
            var elemTop;
            if (moveTo > 0) {
                elemTop = 0;
            } else if (moveTo < self.themeImageDragging.bottomPartToMove) {
                elemTop = self.themeImageDragging.bottomPartToMove;
            } else {
                elemTop = moveTo;
            }
            $(elem).css("background-position", `0px ${elemTop}px`);
            e.preventDefault(); //needed!!! Disables dragging and opening of an image (Firefox), dragging and previewing an image (Chrome)
            console.info("Dragging...");
        }
    }

    calculateAndMoveBackgroundImage(elem) {
        if (!$(elem)) {
            return;
        } //disable the use of edit button, if no custom (user uploaded) image is used.
        var pageConfig = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
        var imagePosition = this.model.get(pageConfig + 'PageConfig').get('backgroundImagePosition');
        var percentage = imagePosition || 0.0;
        $(elem).css("background-position", `0px ${percentage * 100}%`);
    }

    @on('click #toggleImagePositionMovement')
    toggleImageEditMode(e) {
        if (this.model.get("campaignId")) return;

        const toggleButton = $(e.currentTarget);
        const $bg = $("#bg-photo");
        //disable the use of edit button, if no custom (user uploaded) image is used.
        if (!$bg.css('background-image') || $bg.css('background-image') === 'none') return;
        //Disable edit mode and save changes
        if ($bg.hasClass('dragme')) {
            this.draggingCustomBgImage = false;
            $bg.removeClass('dragme');
            toggleButton.text(i18n.t('voucher.taptoedit'));
            $("#cancelImagePositionMovement").hide();
            $("#dragImageText").hide();

            $($bg.parent()).removeClass('editingImagePosition');

            const service = this.model.get("campaignTemplateType") === "TELLODY_VOUCHER" ? "voucher" : "survey";
            const bgImagePosition = this.model.get(service + 'PageConfig').get('backgroundImagePosition');

            this.themeImageDragging.valueToSave = Optional.ofNullable(this.themeImageDragging.valueToSave)
                .or(() => Optional.ofNullable(bgImagePosition))
                .orElse(1.0);

            this.model.get(`${service}PageConfig`)
                .set("backgroundImagePosition", parseFloat(this.themeImageDragging.valueToSave));

            this.calculateAndMoveBackgroundImage.call(this, $bg);
            this.calculateAndMoveBackgroundImage.call(this, $('#bg-photo-mobile'));
            this.calculateAndMoveBackgroundImage.call(this, $('[id="bg-photo-pass"]'));
        } else { //enable edit mode
            const imageContainerDiff = parseInt($bg.css("height")) - this.bgImageDimensions.height;
            //init "background-position" to avoid "undefined" data returned and convert it to px from percentage
            const imageBackgroundPositionY = $bg.css("background-position");

            if (!imageBackgroundPositionY)
                $bg.css("background-position", "0px 0px");
            else if (imageBackgroundPositionY.split(" ")[1].indexOf('%') > -1)
                $bg.css("background-position", `0px ${parseFloat(imageBackgroundPositionY.split(" ")[1]) * imageContainerDiff / 100}px`);

            $("#cancelImagePositionMovement").show();
            $("#dragImageText").show();
            this.draggingCustomBgImage = true;
            $bg.addClass('editingImagePosition')
                .addClass('dragme');

            toggleButton.text(i18n.t('voucher.saveLabel'));
            $("#showlamp").hide();
        }
    }

    toggleCustomImages(visibility) {
        [
            $('#bg-photo'),
            $('#bg-photo-mobile'),
            $('[id="bg-photo-pass"]')
        ].forEach((index, item) => $(item).toggle(visibility !== "hide"));
    }

    toggleBgCustomImageButtons(visibility, isCustomImage) {
        if (visibility === 'show') {
            if (isCustomImage) {
                $('#toggleImagePositionMovement').show();
            }
            if (!this.draggingCustomBgImage) {
                $("#showlamp").show();
            } //do not show "lamp" if dragging image
        } else {
            if (!this.draggingCustomBgImage) {
                $('#toggleImagePositionMovement').hide();
            }
            $("#showlamp").hide();
        }
    }

    toggleBgColorCustomButtons(visibility, isCustomImage) {
        if (visibility === 'show') {
            if (isCustomImage) {
                $('#showcolor').show();
            }
        } else {
            $('#showcolor').hide();
        }
    }

    @on('click #cancelImagePositionMovement')
    cancelDraggingOfCustomImage(e) {
        var self = this;
        e.stopPropagation();

        var toggleButton = $("#toggleImagePositionMovement");
        var img = $("#bg-photo");
        if (!img) {
            return;
        } //disable the use of edit button, if no custom (user uploaded) image is used.
        if (img.hasClass('dragme')) {
            self.draggingCustomBgImage = false;
            img.removeClass('dragme');
            toggleButton.text(i18n.t('voucher.taptoedit'));
            $("#cancelImagePositionMovement").hide();
            $("#dragImageText").hide();

            $(img.parent()).removeClass('editingImagePosition');

            this.calculateAndMoveBackgroundImage.call(this, img);
            $(e.currentTarget).hide();
        }
    }

    transferEventTo(previousEvent, newEvent, elem) {
        if (this.draggingCustomBgImage) {
            previousEvent.preventDefault();
        }
        // set mouse coordinates --- needed for Dragging
        newEvent.pageX = previousEvent.pageX;
        newEvent.pageY = previousEvent.pageY;
        newEvent.transferredFromText = true;

        $(elem).trigger(newEvent);
    }

    /** Visual Helpers Section ~ END **/

    /** Instant Wins Functions Section ~ BEGIN **/
    @on('click #create-winners-group')
    async createInstantWinWinnersGroup(withoutConfirmBox) {
        var self = this;
        var campaignId = this.model.get("campaignId");
        var service = "instantWin";
        var isSweepstakes = this.model.get("description") === "sweepstakes";
        var title = isSweepstakes ? ".newSweepstakesGroupName" : ".winnersGroupTitle";
        var query = `in instantWinWinners(${campaignId})`;
        if (withoutConfirmBox) {
            //check for true, because by not passing `withoutConfirmBox`, `withoutConfirmBox` will be the `event`
            var newWinnersGroup = self.createGroupWithoutRedirecting(title, query, service);
            newWinnersGroup.done(function (responseModel) {
                if (responseModel) {
                    var theModel = new GroupModel(responseModel.attributes);
                    $.Notify.show(i18n.t("instantWin.groupCreatedSuccessfully"));
                    location.reload();
                } else {
                    $.Notify.error(`${i18n.t("instantWin.errorCreatingGroup")} ${responseModel}`);
                    location.reload();
                }
            }).fail(function (r) {
                $.Notify.error(i18n.t("instantWin.errorCreatingGroup"));
            });
        } else {
            var text = isSweepstakes ? i18n.t("instantWin.createSweepstakesWinnersGroup") : i18n.t("instantWin.createWinnersGroup");
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: text,
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no"),
            });
            if (result) {
                self.createGroup(title, query, service);
            }
        }
    }

    @on('click .serviceTab')
    changeServiceTab(e) {
        var self = this;
        var $currentTarget = $(e.currentTarget);
        var $currentTargetParent = $($currentTarget.parent());
        var $currentlyActiveTab = $($currentTargetParent.parent().find('.active'));

        $currentlyActiveTab.removeClass("active");
        $currentTargetParent.addClass('active');

        self.calculateAndUpdatePostEntryMask();
        var $mobilePreviewMask = $($(".preview .previewMask")[0]);

        var currentlyActiveTabDataId = $currentlyActiveTab.find(".serviceTab").data("id");
        $(`[id="${currentlyActiveTabDataId}"]`).hide();

        //if `Entry` tab button was clicked, just hide the currently active tab. No need to show anything
        var tabToShow = $currentTarget.data("id");
        if (tabToShow !== "defaultTab") {
            $(`[id="${tabToShow}"]`).show();
            $mobilePreviewMask.show();
        } else {
            $mobilePreviewMask.hide();
        }
    }

    @on('click #closeRulesPopup')
    closeRulesPopup(e) {
        var isForPreview = $(e.currentTarget).data("for-preview");
        if (isForPreview) {
            $("#instantWinParticipationRulesPopupPreviewContainer").hide();
        } else {
            $("#instantWinParticipationRulesPopup").hide();
        }
    }

    @on('click #openRulesPopup')
    openRulesPopup(e) {
        var isForPreview = $($(e.currentTarget).parent()).data("for-preview");
        if (isForPreview) {
            $("#instantWinParticipationRulesPopupPreviewContainer").show();
        } else {
            $("#instantWinParticipationRulesPopup").show();
        }
    }

    /** Instant Wins Functions Section ~ END **/
}

export default ServiceGenericView;
